import {
  Smiley,
  Heart,
  Eye,
  EyeSlash,
  ShoppingCart,
  Bell,
  CaretDown,
  MagnifyingGlass,
  MapPin,
  CalendarBlank,
  XCircle,
} from 'phosphor-react';

import Cart from './cart.svg';
import User from './user.svg';
import Ticket from './ticket.svg';
import Logout from './logout.svg';
import Instagram from './instagram.svg';
import Facebook from './facebook.svg';
import FlagBrazil from './flag-brasil.svg';
import FlagSpanish from './flag-espanha.svg';
import FlagEua from './flag-eua.svg';
import Close from './close.svg';
import Google from './google.svg';
import IconFacebook from './btn-facebook.svg';
import Apple from './apple.svg';
import IconEye from './eye.svg';
import IconEyeClose from './eye-disabled.svg';
import Calendar from './calendar.svg';
import CalendarGrey from './calendar-grey.svg';
import Check from './check.svg';
import Hamburger from './hamburger.svg';
import Search from './search.svg';
import Area from './area.svg';
import Cupom from './cupom.svg';
import CheckSuccess from './check-success.svg';
import CartEmpty from './cart-empty.svg';
import Trash from './trash.svg';
import ArrowLeft from './arrow-left.svg';
import Codebar from './codebar.svg';
import QRcode from './qr-code.svg';
import { IconTicketPayment } from './IconTicketPayment';
import { IconSecurity } from './IconSecurity';
import { IconPix } from './IconPix';
import { IconCreditCard, IconCreditCard1 } from './IconCreditCard';
import { IconCheckSuccess } from './IconCheckSuccess';
import { IconClose } from './IconClose';
import { IconSearch } from './IconSearch';
import { IconUser } from './IconUser';
import { IconCalendar } from './IconCalendar';
import { IconError } from './IconError';
import { IconExclamation } from './IconExclamation';
import { IconInstagram } from './IconInstagram';
import { IconFacebook2 } from './IconFacebook';
import SupportIcon from './supportIcon.svg';
import IconWarning from './icon-warning.svg';

enum Sizes {
  nano = 8,
  xsmall = 16,
  small = 12,
  xmedium = 24,
  medium = 28,
  xlarge = 64,
  xxlarge = 48,
  xxxlarge = 36,
  large = 72,
}

export {
  Sizes,
  Smiley,
  Heart,
  Eye,
  EyeSlash,
  ShoppingCart,
  Bell,
  CaretDown,
  MagnifyingGlass,
  MapPin,
  CalendarBlank,
  CalendarGrey,
  Cart,
  Instagram,
  Facebook,
  FlagBrazil,
  FlagSpanish,
  FlagEua,
  User,
  Ticket,
  Logout,
  XCircle,
  Close,
  Google,
  IconFacebook,
  Apple,
  IconEye,
  IconEyeClose,
  Calendar,
  Check,
  Hamburger,
  Search,
  Area,
  Cupom,
  CheckSuccess,
  CartEmpty,
  Trash,
  ArrowLeft,
  Codebar,
  QRcode,
  IconTicketPayment,
  IconSecurity,
  IconPix,
  IconCreditCard,
  IconCreditCard1,
  IconCheckSuccess,
  IconClose,
  IconSearch,
  IconUser,
  IconCalendar,
  IconError,
  IconExclamation,
  IconInstagram,
  IconFacebook2,
  SupportIcon,
  IconWarning,
};
